import { cn } from '../lib/utils';

/**
 * Default tag colors - consistent across all tag-related components
 */
export const TAG_COLORS: readonly string[] = [
  '#ef4444', // red
  '#f97316', // orange
  '#eab308', // yellow
  '#22c55e', // green
  '#14b8a6', // teal
  '#3b82f6', // blue
  '#8b5cf6', // violet
  '#ec4899', // pink
  '#6b7280', // gray
];

export const DEFAULT_TAG_COLOR: string = '#3b82f6'; // blue

export interface TagColorPickerProps {
  /** Currently selected color */
  value: string;
  /** Called when color changes */
  onChange: (color: string) => void;
  /** Available colors (defaults to TAG_COLORS) */
  colors?: readonly string[];
  /** Size variant */
  size?: 'sm' | 'default';
  /** Additional class names */
  className?: string;
}

/**
 * Color picker for tags - displays a row of color circles
 */
function TagColorPicker({
  value,
  onChange,
  colors = TAG_COLORS,
  size = 'default',
  className,
}: TagColorPickerProps) {
  const sizeClasses = {
    sm: 'size-5',
    default: 'size-6',
  };

  return (
    <div className={cn('flex flex-wrap gap-2', className)}>
      {colors.map((color) => (
        <button
          key={color}
          type="button"
          className={cn(
            'rounded-full border-2 transition-transform hover:scale-110',
            sizeClasses[size],
            value === color ? 'border-foreground scale-110' : 'border-transparent'
          )}
          style={{ backgroundColor: color }}
          onClick={() => onChange(color)}
          aria-label={`Select color ${color}`}
        />
      ))}
    </div>
  );
}

export { TagColorPicker };
